import { render } from "./MTShop.vue?vue&type=template&id=29149ffc&scoped=true&ts=true"
import script from "./MTShop.vue?vue&type=script&lang=ts"
export * from "./MTShop.vue?vue&type=script&lang=ts"

import "./MTShop.vue?vue&type=style&index=0&id=29149ffc&scoped=true&lang=css"
import "./MTShop.vue?vue&type=style&index=1&id=29149ffc&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29149ffc"]])

export default __exports__